import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";

import history from "../../history";

import { connect } from "react-redux";

import Form from "./Form";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from "@material-ui/core";

import { ExpandMore } from "@material-ui/icons";

import { getShift, duplicateShift } from "../../actions/shiftActions";

import RepeatSelector from "./RepeatSelector";

import repeatSelectionToDateTimes from "../../helpers/repeatSelectionToDateTimes";

import { useTranslation } from "react-i18next";

import ConfirmationDialog from "../ConfirmationDialog";

import moment from "moment";

const DuplicateShiftForm = (props) => {
  const { t } = useTranslation();

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const [includeEmployees, setIncludeEmployees] = useState(true);
  const [repeatSelection, setRepeatSelection] = useState({});
  const [datetimes, setDatetimes] = useState([]);

  const [shift, setShift] = useState(null);

  const duplicateShift = async () => {
    props
      .duplicateShift(props.shiftId, { datetimes, includeEmployees })
      .then(() => history.goBack());
  };

  useEffect(() => {
    props.getShift(props.shiftId).then((shift) => setShift(shift));
  }, []);

  useEffect(() => {
    if (!shift) return;
    const shiftDatesDiff = Math.abs(
      moment(shift.endDatetime).diff(moment(shift.beginDatetime)),
    );
    const datetimes = repeatSelectionToDateTimes({
      ...repeatSelection,
      baseDateTime: shift.beginDatetime,
    }).map((d) => ({
      beginDatetime: d,
      endDatetime: moment(d).add(shiftDatesDiff).toDate(),
    }));
    setDatetimes(datetimes);
  }, [shift, repeatSelection]);

  return (
    <Fragment>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          setIsDialogOpen(true);
        }}
        submitText="Dupliceren"
        isFetching={props.isFetching}
        successMessage={props.successMessage}
        errorMessage={props.errorMessage}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <RepeatSelector
              onChange={(selection) => setRepeatSelection(selection)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  id="includeEmployees"
                  name="includeEmployees"
                  checked={includeEmployees}
                  onChange={(e) => setIncludeEmployees(e.target.checked)}
                />
              }
              label="Ingeplande medewerkers dupliceren?"
            />
          </Grid>
        </Grid>
        <br />
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              {datetimes.length}{" "}
              {t(datetimes.length === 1 ? "shift" : "shifts")}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("start_date")}</TableCell>
                    <TableCell>{t("end_date")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datetimes.map((datetime, index) => (
                    <TableRow
                      key={index}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {datetime.beginDatetime.toLocaleDateString("nl-NL", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </TableCell>
                      <TableCell>
                        {datetime.endDatetime.toLocaleDateString("nl-NL", {
                          weekday: "long",
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </AccordionDetails>
        </Accordion>
      </Form>
      <ConfirmationDialog
        title={"Weet u het zeker?"}
        open={isDialogOpen}
        onConfirmed={() => {
          setIsDialogOpen(false);
          duplicateShift();
        }}
        onClose={() => setIsDialogOpen(false)}
      />
    </Fragment>
  );
};

DuplicateShiftForm.propTypes = {
  shiftId: PropTypes.string.isRequired,
  getShift: PropTypes.func.isRequired,
  duplicateShift: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.arrayOf(PropTypes.string),
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shift.duplicateShift.successMessage,
  errorMessage: state.shift.duplicateShift.errorMessage,
  isFetching:
    state.shift.getShift.isFetching || state.shift.duplicateShift.isFetching,
});

export default connect(mapStateToProps, {
  getShift,
  duplicateShift,
})(DuplicateShiftForm);



// WEBPACK FOOTER //
// ./src/components/forms/DuplicateShiftForm.js